import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
} from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import './style.css'
import './dark-global.css'
import TermsOfUse from './views/terms-of-use'
import PrivacyPolicy from './views/privacy-policy'
import Blog from './views/blog'
import BlogPostView from './views/blog-post-view'
import ContactUs from './views/contact-us'
import NotFound from './views/not-found'
import MicrosoftTeamsIntegration from './views/integrations/microsoft-teams'
import EmailToSmsIntegration from './views/integrations/email-to-sms'
import PowerAutomateIntegration from './views/integrations/power-automate'
import PowerAutomateAdvanced from './views/integrations/power-automate-advanced'
import PowerAutomateUseCases from './views/integrations/power-automate-use-cases'
import ZapierIntegration from './views/integrations/zapier'
import SupabaseIntegration from './views/integrations/supabase'
import Auth0Integration from './views/integrations/auth0'
import ShopifyIntegration from './views/integrations/shopify'
import WordPressIntegration from './views/integrations/wordpress'
import HomeV2 from './views/home-v2'
import SmsCompliance from './views/sms-compliance'
import About from './views/about'
import SenderIdRegistration from './views/sender-id-registration'
import AnalyseSentimentAI from './views/integrations/zapier/analyse-sentiment-ai'
import SendSms from './views/integrations/zapier/send-sms'
import CreateContact from './views/integrations/zapier/create-contact'
import CategoriseSmsAI from './views/integrations/zapier/categorise-sms-ai'
import NewSmsReceived from './views/integrations/zapier/new-sms-received'
import KeywordMatched from './views/integrations/zapier/keyword-matched'
import SmsDeliveryStatus from './views/integrations/zapier/sms-delivery-status'
import LowBalanceAlert from './views/integrations/zapier/low-balance-alert'
import GoHighLevelIntegration from './views/integrations/gohighlevel'
import ClinikoIntegration from './views/integrations/cliniko'
import MondayIntegration from './views/integrations/monday'
import ClaudeIntegration from './views/integrations/claude'
import ChatGPTIntegration from './views/integrations/chatgpt'
import GeminiIntegration from './views/integrations/gemini'
import IntegrationsHub from './views/integrations-hub'
import Developers from './views/developers'

// Stagewise toolbar imports (development only)
import { StagewiseToolbar } from '@stagewise/toolbar-react'
import { ReactPlugin } from '@stagewise-plugins/react'

const ScrollToTop = () => {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

const App = () => {
  return (
    <HelmetProvider>
    <Router>
      {/* Stagewise toolbar - only in development */}
      {process.env.NODE_ENV === 'development' && (
        <StagewiseToolbar
          config={{
            plugins: [ReactPlugin],
          }}
        />
      )}
      <ScrollToTop />
      <Switch>
        <Route component={TermsOfUse} exact path="/terms-of-use" />
        <Route component={PrivacyPolicy} exact path="/privacy-policy" />
        <Route component={SmsCompliance} exact path="/sms-compliance" />
        <Route component={SenderIdRegistration} exact path="/sender-id-registration" />
        <Route component={Blog} exact path="/blog" />
        <Route component={BlogPostView} exact path="/blog/:slug" />
        <Route component={ContactUs} exact path="/contact-us" />
        <Route component={About} exact path="/about" />
        <Route component={MicrosoftTeamsIntegration} exact path="/integrations/microsoft-teams" />
        <Route component={EmailToSmsIntegration} exact path="/integrations/email-to-sms" />
        <Route component={AnalyseSentimentAI} exact path="/integrations/zapier/actions/analyse-sentiment-ai" />
        <Route component={SendSms} exact path="/integrations/zapier/actions/send-sms" />
        <Route component={CreateContact} exact path="/integrations/zapier/actions/create-contact" />
        <Route component={CategoriseSmsAI} exact path="/integrations/zapier/actions/categorise-sms-ai" />
        <Route component={NewSmsReceived} exact path="/integrations/zapier/triggers/new-sms-received" />
        <Route component={KeywordMatched} exact path="/integrations/zapier/triggers/keyword-matched" />
        <Route component={SmsDeliveryStatus} exact path="/integrations/zapier/triggers/sms-delivery-status" />
        <Route component={LowBalanceAlert} exact path="/integrations/zapier/triggers/low-balance-alert" />
        <Route component={ZapierIntegration} exact path="/integrations/zapier" />
        <Route component={SupabaseIntegration} exact path="/integrations/supabase" />
        <Route component={Auth0Integration} exact path="/integrations/auth0" />
        <Route component={ShopifyIntegration} exact path="/integrations/shopify" />
        <Route component={WordPressIntegration} exact path="/integrations/wordpress" />
        <Route component={GoHighLevelIntegration} exact path="/integrations/gohighlevel" />
        <Route component={ClinikoIntegration} exact path="/integrations/cliniko" />
        <Route component={MondayIntegration} exact path="/integrations/monday" />
        <Route component={ClaudeIntegration} exact path="/integrations/claude" />
        <Route component={ChatGPTIntegration} exact path="/integrations/chatgpt" />
        <Route component={GeminiIntegration} exact path="/integrations/gemini" />
        <Route component={PowerAutomateAdvanced} exact path="/integrations/power-automate/advanced" />
        <Route component={PowerAutomateUseCases} exact path="/integrations/power-automate/use-cases" />
        <Route component={PowerAutomateIntegration} exact path="/integrations/power-automate" />
        <Route component={IntegrationsHub} exact path="/integrations" />
        <Route component={Developers} exact path="/developers" />
        <Route component={HomeV2} exact path="/" />
        <Redirect from="/privacy" to="/privacy-policy" />
        <Redirect from="/sms-for-woocommerce" to="/integrations/wordpress" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
    </HelmetProvider>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
